import { FILE_TYPE_ENUM } from "../../../enums/file-type";
import facilitiesService from "@/services/facilities";
import fileDownload from "js-file-download";

export class FacilitiesExportFactory {
  constructor() {
    this.file = null;
    this.fileExtension = null;
    this.fileName = null;
  }

  async makeExport({ fileType, ids }) {
    switch (fileType) {
      case FILE_TYPE_ENUM.CSV:
        this.fileExtension = "csv";
        await this._getExportFile(ids);
        break;
      case FILE_TYPE_ENUM.XLS:
        this.fileExtension = "xls";
        await this._getExportFile(ids);
        break;
      case FILE_TYPE_ENUM.XLSX:
        this.fileExtension = "xlsx";
        await this._getExportFile(ids);
        break;
    }
  }

  downloadFile() {
    fileDownload(this.file, this.fileName);
  }

  async _getExportFile(ids) {
    const { data, headers } = await facilitiesService.exportFacilities({
      type: this.fileExtension,
      ids
    });
    const contendDisposition = headers["content-disposition"];
    this.fileName = contendDisposition
      .split("filename=")[1]
      .replace(/['"]+/g, "");

    this.file = data;
  }
}
